import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as RepeatIcon } from './repeat.svg';

export const Repeat = IconHOC(RepeatIcon);
